import React from 'react';
import useTheLab from 'pages/TheLab/data/useTheLab';
import { PageContent } from 'ui/layouts';
import GoBackToTheFlowPage from 'ui/GoBackToTheFlowPage';
import { SectionHeader, Title } from 'pages/TheLab/styles';
import Courses from 'pages/TheLab/Courses';

const TheLab = () => {
  const { data } = useTheLab();

  return (
    <PageContent>
      <GoBackToTheFlowPage />
      <SectionHeader>
        <Title>Video Library</Title>
        <p>
          Learn everything you want to know about essential oils, dōTERRA, and
          even how to launch and grow a successful online business of your own –
          all on your own time and at your own pace.
        </p>
      </SectionHeader>
      <Courses courses={data} />
    </PageContent>
  );
};

export default TheLab;
